import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const initialState = {
  selectedDay: "",
  selectedTimeslotId: "",
  selectedBookingId: "",
  timeslotListUpdate: 0,
}

const prenotationViewReducer = createSlice({
  name: 'PrenotationView',
  initialState,
  reducers: {
    updateSelectedDay(state, action: PayloadAction<string>) {
      state.selectedDay = action.payload;
    },
    updateSelectedTimeslotId(state, action: PayloadAction<string>) {
      state.selectedTimeslotId = action.payload;
    },
    updateSelectedBookingId(state, action: PayloadAction<string>) {
      state.selectedBookingId = action.payload;
    },
    updatePrenotationViewAll(state, action: PayloadAction<string[]>) {
      state.selectedDay = action.payload[0];
      state.selectedTimeslotId = action.payload[1];
      state.selectedBookingId = action.payload[2];
    },
    forceTimeslotListUpdate(state) {
      state.timeslotListUpdate++;  // update to trigger a timeslot list update
    },
  }
})

export const {
  updateSelectedDay,
  updateSelectedTimeslotId,
  updateSelectedBookingId,
  updatePrenotationViewAll,
  forceTimeslotListUpdate,
} = prenotationViewReducer.actions

export default prenotationViewReducer.reducer
